import React from 'react';
import MegaMenuItem from '../MegaMenuItem';
import { GroupSubMenuContainer } from './styles';

const GroupSubMenu = ({ isMenuOpened, setMobileMenuOpened, subNavElements = [] }) => {
  const groups = [...new Set(subNavElements.map(item => item.group?.group))];
  const menuItems = groups
    .map(item => ({
      group: item,
      items: subNavElements.filter(navItem => navItem.group?.group === item),
    }))
    .filter(groupMenu => groupMenu.items.length > 0);

  return (
    <GroupSubMenuContainer className="mega-menu" isMenuOpened={isMenuOpened}>
      <div className="group-sub-menu--container">
        {menuItems.map((groupMenu, index) => (
          <div className="group-sub-menu--group-container" key={index}>
            <p className="group-sub-menu--sub-title">{groupMenu.group}</p>
            <ul className="group-sub-menu--menu-content">
              {groupMenu.items.map((item, index1) => {
                const { description, icon, label, url } = item;
                return (
                  <MegaMenuItem
                    type="icon-title-desc"
                    icon={icon?.image?.file?.url}
                    alt={icon?.alt}
                    title={label}
                    link={url}
                    key={index1}
                    setMobileMenuOpened={setMobileMenuOpened}
                  >
                    {description}
                  </MegaMenuItem>
                );
              })}
            </ul>
          </div>
        ))}
      </div>
    </GroupSubMenuContainer>
  );
};

export default GroupSubMenu;
